import React from "react";
import FixedAssetsWriteOffsGenericSkeleton from "./FixedAssetsWriteOffsGenericSkeleton";

function FixedAssetsWriteOffsDetailsSkeleton() {
  return (
    <>
      <FixedAssetsWriteOffsGenericSkeleton />
    </>
  );
}

export default FixedAssetsWriteOffsDetailsSkeleton;
